<template>
  <div>
    <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="cancelDialogVisible" width="650px" append-to-body>
      <el-form label-width="120px" inline>
        <div v-if="cancelForm.docType=='promotion_card_use'">
          <el-form-item label="会员名称">
            {{cancelForm.memberName}}
          </el-form-item>
          <el-form-item label="手机号码">
            {{cancelForm.mobilePhone}}
          </el-form-item>
          <el-form-item label="促销名称">
            {{cancelForm.tradeName}}
          </el-form-item>
          <el-form-item label="成交金额">
            <span class="text-red text-price">
              {{cancelForm.tradeMoney}}
            </span>
          </el-form-item>
          <el-form-item label="欠款金额">
            <span class="text-cyan text-price">
              {{cancelForm.debtMoney}}
            </span>
          </el-form-item>
          <el-form-item label="取消欠款">
            <span class="text-cyan text-price">
              {{cancelForm.cancelMoney}}
            </span>
          </el-form-item>
          <el-table :data="cancelForm.cancelDebtMxes" highlight-current-row tooltip-effect="dark">
            <el-table-column prop="courseProjectNum" show-overflow-tooltip label="项目编码" align="center" min-width="80"></el-table-column>
            <el-table-column prop="courseProjectName" show-overflow-tooltip label="项目名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="price" show-overflow-tooltip label="欠款" align="center" min-width="80">
              <el-table-column prop="debtMoney" show-overflow-tooltip label="金额" align="center" min-width="80"></el-table-column>
              <el-table-column prop="debtCount" show-overflow-tooltip label="次数" align="center" min-width="80"></el-table-column>
            </el-table-column>
            <el-table-column prop="price" show-overflow-tooltip label="取消欠款" align="center" min-width="80">
              <el-table-column prop="cancelMoney" show-overflow-tooltip label="金额" align="center" min-width="80">
                <template slot-scope="scope">
                  <div @click.stop v-if="title=='修改'">
                    <div class="text-cyan" v-if="editCancelMIndex!=scope.$index" @click="openEditCancelM(scope.row,scope.$index,editCancelMIndex=scope.$index)">
                      {{scope.row.cancelMoney}}
                      <i class="el-icon-edit text-cyan"></i>
                    </div>
                    <el-input v-focus type="number" class="form-input-width-xs" v-else @blur="endEditCancelM(scope.row,editCancelMIndex=-1)" v-model="scope.row.cancelMoney"></el-input>
                  </div>
                  <div v-else>{{scope.row.cancelMoney}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="cancelNum" show-overflow-tooltip label="次数" align="center" min-width="80">
                <template slot-scope="scope">
                  <div @click.stop v-if="title=='修改'">
                    <div class="text-cyan" v-if="editCancelCIndex!=scope.$index" @click="openEditCancelC(scope.row,scope.$index,editCancelCIndex=scope.$index)">
                      {{scope.row.cancelNum}}
                      <i class="el-icon-edit text-cyan"></i>
                    </div>
                    <el-input v-focus type="number" class="form-input-width-xs" v-else @blur="endEditCancelC(scope.row,editCancelCIndex=-1)" v-model="scope.row.cancelNum"></el-input>
                  </div>
                  <div v-else>{{scope.row.cancelNum}}</div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-form-item label="用户名">
            <div style="width: 150px;">
              {{cancelForm.memberName}}
            </div>
          </el-form-item>
          <el-form-item label="手机号">
            <div style="width: 150px;">
              {{cancelForm.mobilePhone}}
            </div>
          </el-form-item>
          <el-form-item label="类型">
            <div style="width: 150px;">
              {{cancelForm.docType=='card_use'?'疗程':cancelForm.docType=='promotion_card_use'?'促销':cancelForm.liftType==1?'升降级':'正常充值'}}
            </div>
          </el-form-item>
          <el-form-item label="时间">
            <div style="width: 150px;">
              {{cancelForm.docDate}}
            </div>
          </el-form-item>
          <el-form-item label="欠款帐户">
            <div style="width: 150px;">
              {{cancelForm.tradeName}}
            </div>
          </el-form-item>
          <el-form-item label="成交金额">
              <div style="width: 150px;">
                <span class="text-red text-price">{{cancelForm.tradeMoney}}</span>
              </div>
          </el-form-item>
          <el-form-item label="欠款金额">
            <div style="width: 150px;">
              <span class="text-cyan text-price">
                {{cancelForm.debtMoney}}
              </span>
            </div>
          </el-form-item>
          <el-form-item label="取消欠款金额">
            <el-input type="number"  v-model="cancelForm.cancelMoney"></el-input>
          </el-form-item>
          <el-form-item label="取消欠款次数" v-if="cancelForm.docType == 'card_use'">
            <el-input pattern="[0-9]*\" type="number" v-model="cancelForm.cancelNum"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" plain @click="cancelDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
        cancelForm:{},
        cancelDialogVisible:false,
        title:"取消欠款"
    }
  },
  methods: {
    init(row){
        this.cancelForm = {...row}
        this.cancelDialogVisible = true
    }
  },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/order/cancelDeb.vue